const video = document.createElement('video');

// TODO Not entirely sure about this check https://stackoverflow.com/a/71914018 and
//  https://stackoverflow.com/a/63954128
export const isH265Supported =
  video.canPlayType('video/mp4; codecs="hev1"') ||
  video.canPlayType('video/mp4; codecs="hvc1"');
